/**
 * **「이 세션에 그 액션이 있는가」 한 곳** — 의존성이 없는 순수 모듈이다(Vue·스토어·`@/` 별칭 금지).
 *
 * 같은 술어가 네 곳에 각자 적혀 있었다: `utils/checkAuthActionAccess`(화면 버튼)·`router/index.js`
 * (`meta.requiredAction` 게이트)·`plugins/http/permittedRead`(조회 게이트, 앞의 것을 재사용)·
 * `stores/menu.js`(`MainMenu` 게이트). 지금은 네 사본의 동작이 우연히 같아서 **더 위험하다** — 나중에 한
 * 곳만 규칙을 얻으면 메뉴는 그리는데 요청은 막히거나 그 반대가 되고, 그 어긋남은 로그인 셸에서만 드러난다.
 *
 * `stores/menu.js` 가 `checkAuthActionAccess` 를 그대로 부르지 못하는 이유는 실재한다 — 그 유틸이
 * `@/stores` 를 읽고 `stores/index.js` 가 `stores/menu.js` 를 읽어 **순환 import** 가 된다. 그래서
 * 「그냥 import 하라」가 아니라 **순수 술어를 빼낸다**: 이 파일은 세션 객체를 인자로만 받는다.
 */

/**
 * 세션에 이 액션이 있는가 — 세션이 없거나 `sa_actions` 가 없으면 **거짓**이다.
 *
 * 「모른다」를 참으로 접지 않는다: 로그인 전·복구 중의 빈 세션에 버튼을 그리면 그 클릭이 403 이 되고,
 * 이 앱의 403 은 세션을 끝낸다.
 *
 * @param {?object} auth 세션 스냅샷(`auth/auth` 게터) — `{ sa_actions: string[] }`
 * @param {?string} actionId 액션 id (예: `'AccountGet'`)
 * @returns {boolean}
 */
export function hasAction(auth, actionId) {
  if (!actionId) return false

  const actions = auth && auth.sa_actions

  return Array.isArray(actions) && actions.indexOf(actionId) > -1
}
